import React from "react";
import { TrainingMethod } from "../../../../model_gen/finetuning";
import { Card, CardContent, CardHeader, CardTitle } from "../../../ui/card";
import { FlaskConicalIcon } from "lucide-react";

interface TrainingMethodStepProps {
  trainingMethod: TrainingMethod;
  setTrainingMethod: (value: TrainingMethod) => void;
  isDisabled?: boolean;
}

const METHODS: Array<{
  key: TrainingMethod;
  label: string;
  description: string;
  compositionNote: string;
}> = [
  {
    key: "SFT",
    label: "SFT",
    description: "Supervised fine-tuning on input/output pairs",
    compositionNote: "Uses SFT compositions",
  },
  {
    key: "DPO",
    label: "DPO",
    description: "Direct Preference Optimization on chosen/rejected pairs",
    compositionNote: "Uses RL compositions",
  },
  {
    key: "GRPO",
    label: "GRPO",
    description: "Group Relative Policy Optimization with online RL",
    compositionNote: "Uses RL compositions",
  },
];

const TrainingMethodStep: React.FC<TrainingMethodStepProps> = ({
  trainingMethod,
  setTrainingMethod,
  isDisabled = false,
}) => {
  return (
    <div className="space-y-8">
      <div className="text-center space-y-3">
        <h2 className="text-2xl font-gc-demi-bold text-foreground">
          Training Method
        </h2>
        <p className="text-muted-foreground font-gc-reg">
          Choose how the model will be trained. This determines which
          compositions are available.
        </p>
      </div>

      <Card className="border-border">
        <CardHeader className="pb-4">
          <CardTitle className="flex items-center gap-2 text-lg font-gc-med text-foreground">
            <FlaskConicalIcon className="w-5 h-5 text-maitai-green" />
            Select Method
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            {METHODS.map((m) => (
              <button
                key={m.key}
                type="button"
                onClick={() => setTrainingMethod(m.key)}
                disabled={isDisabled}
                className={`rounded-lg border-2 p-5 text-left transition-colors ${
                  trainingMethod === m.key
                    ? "border-maitai-green bg-maitai-green/5"
                    : "border-border hover:border-muted-foreground/40"
                } ${isDisabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer"}`}
              >
                <div className="text-base font-gc-med text-foreground">
                  {m.label}
                </div>
                <div className="text-sm text-muted-foreground mt-1">
                  {m.description}
                </div>
                <div className="text-xs text-muted-foreground/70 mt-3">
                  {m.compositionNote}
                </div>
              </button>
            ))}
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default TrainingMethodStep;
